import React, { useState, useContext } from "react";
import { Button, Icon, Card, Label, Switch, Tooltip } from "@pmi/nyx-design-system";
import { FiltersContext } from "../../context/filterscontext";
import { ApiContext } from "../../context/apicontext";

// External_Data Dropdown code
function ExternalData() {
    const [catchmentAreas, setCatchmentAreas] = useState({ 1: 'Off', 2: 'Off', 3: 'Off', 4: 'Off'});
    const { isCardOpen, setIsCardOpen, dropdownRefs } = useContext(FiltersContext);
    const {filterData} = useContext(ApiContext);

    const handleCatchmentData = (id, value) => {
        setCatchmentAreas((prev) => ({ ...prev, [id]: value }));
    };

    return (
        <>
            <div className="position-relative" ref={dropdownRefs.externalData}>
                <Button variant="primary" onClick={() => setIsCardOpen({ touchpoints: false, externalData: !isCardOpen.externalData })}>
                    External Data <Icon className="mt-1" name={isCardOpen.externalData ? "chevron-up" : "chevron-down"} />
                </Button>
                {isCardOpen.externalData && (
                    <Card className="dropdown-panel position-absolute px-1 py-2" width="100%">
                        <div className="p-4 pb-0">
                            <div className="d-flex justify-content-between align-items-center border-bottom pb-4">
                                <h5 className="text-dark fw-bold">External data</h5>
                                <a href="#" className="fw-bold">Reset</a>
                            </div>
                            <div className="add-geodata-wrapper my-3"><Button outlined>Save as default</Button></div>
                            {/* <Tooltip align="left" side="right" content={
                                <div>
                                    <h6 className="fw-bold">Save your default filter setup</h6><br />
                                    <p style={{ fontSize: "13px", color: "#555", wordWrap: 'normal' }}>
                                        After you'll decide which External Data you'd usually want to have visible, you can save it as a default.
                                    </p>
                                    <button className="TouchModel_close">Close</button>
                                </div>
                            } trigger={<div className="add-geodata-wrapper my-3">
                                <Button outlined>Save as default</Button>
                            </div>} /> */}
                        </div>

                        <div className="filter-innerdata">
                            {/* external data List */}
                            {filterData.externalData.map((point) => (
                                <div key={point.id} className="py-3 border-bottom">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="extradata-icon me-2 flag-wrapper">
                                                <Icon color="white" name={point.icon} size="small" className="" />
                                            </div>
                                            <Label className="text-transform-none">{point.name} ({point.count})</Label>
                                        </div>
                                        <Switch size="medium" className="switch" />
                                    </div>

                                    {/* Catchment Area */}
                                    <div className="mt-2 justify-content-center ms-3 ps-3">
                                        <Label className="small fw-bold ms-1">Catchment area (min)</Label>
                                        <div className="d-flex align-items-center p-1 rounded-3 catchment-btn-wrapper">
                                            {["Off", "5", "10", "15"].map((option) => (
                                                <Button
                                                    key={option}
                                                    size="small"
                                                    variant={catchmentAreas[point.id] === option ? "black" : "white"}
                                                    className={(catchmentAreas[point.id] === option ? "active bg-white text-black border rounded-2 py-2" : "border-0 border-end py-0 bg-transparent") + " px-3 w-100" }
                                                    onClick={() => handleCatchmentData(point.id, option)}
                                                    style={{ border: 'none', backgroundColor: '#F1F5F9', height: '44px' }}
                                                >
                                                    {option}
                                                </Button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <div className="add-geodata-wrapper my-4">
                                <Button outlined><Icon name="plus" color="primary"></Icon>Add external geo data</Button>
                            </div>
                        </div>
                    </Card>
                )}
            </div>
        </>
    )
}
export default ExternalData;